<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="users-consent-policy">
    <div class="users-consent-policy__header">
      <div class="users-consent-policy__title">
        Согласие на обработку персональных данных Специалистов
      </div>
      <div class="users-consent-policy__date">
        Дата публикации: <time class="users-consent-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="users-consent-policy__list">
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            Настоящим я, в соответствии с требованиями Федерального закона от 27.07.2006 №
            152-ФЗ «О персональных данных», свободно, своей волей и в своем интересе даю
            согласие Обществу с ограниченной ответственностью «ЛИГАЛ АДС ТЕХ» (ОГРН
            1227700103245, ИНН 9709078420, далее — Оператор) на обработку моих
            персональных данных на изложенных ниже условиях.
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">
          1. Перечень обрабатываемых персональных данных
        </div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">1.1. Фамилия, имя, отчество;</p>
          <p class="users-consent-policy__item-paragraph">
            1.2. Адрес электронной почты;
          </p>
          <p class="users-consent-policy__item-paragraph">1.3. Номер телефона;</p>
          <p class="users-consent-policy__item-paragraph">
            1.4. Сведения об образовании и профессиональном статусе (включая реестровый
            номер адвоката — при наличии);
          </p>
          <p class="users-consent-policy__item-paragraph">1.5. ИНН;</p>
          <p class="users-consent-policy__item-paragraph">
            1.6. Паспортные данные (в объеме, необходимом для верификации);
          </p>
          <p class="users-consent-policy__item-paragraph">1.7. Фотографии;</p>
          <p class="users-consent-policy__item-paragraph">
            1.8. Адрес места приема (офиса);
          </p>
          <p class="users-consent-policy__item-paragraph">1.9. Платёжные данные;</p>
          <p class="users-consent-policy__item-paragraph">
            1.10. Сведения о Записях и иных обращениях Заказчиков, поступивших мне через
            сервис «Юрик.ру», и их статусах;
          </p>
          <p class="users-consent-policy__item-paragraph">
            1.11. Аудиозаписи телефонных разговоров с Оператором;
          </p>
          <p class="users-consent-policy__item-paragraph">
            1.12. IP-адрес, файлы cookies, данные метрических программ (например,
            Яндекс.Метрика);
          </p>
          <p class="users-consent-policy__item-paragraph">
            1.13. Иные данные, предоставленные мной Оператору.
          </p>
          <p class="users-consent-policy__item-paragraph">
            Предоставляя указанные сведения, я гарантирую их достоверность и владение ими
            на законном основании; по требованию Оператора обязуюсь предоставить
            подтверждающие документы.
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">2. Цели обработки</div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            2.1. Идентификация и верификация в качестве Специалиста, заключение и
            исполнение договоров с Оператором;
          </p>
          <p class="users-consent-policy__item-paragraph">
            2.2. Ведение Личного кабинета и Лицевого счета, приём и сопровождение Записей
            и иных обращений Заказчиков независимо от способа их поступления
            (самостоятельная запись Заказчика, запись оператором Оператора, телефонное
            обращение, вопрос, заявка), расчёты;
          </p>
          <p class="users-consent-policy__item-paragraph">
            2.3. Связь со мной: уведомления, запросы, ответы, документы о платежах и
            расчетах, документы, имеющие правовое значение;
          </p>
          <p class="users-consent-policy__item-paragraph">
            2.4. Запись телефонных разговоров с Оператором в целях контроля качества,
            подтверждения фактов обращений и проверки исходов Записей;
          </p>
          <p class="users-consent-policy__item-paragraph">
            2.5. Направление сообщений рекламного и информационного характера по
            электронной почте, СМС и иным каналам (согласие на получение рекламных
            сообщений предоставляется отдельным действием и может быть отозвано в любой
            момент);
          </p>
          <p class="users-consent-policy__item-paragraph">
            2.6. Поддержание и улучшение функций Сайта, статистические исследования на
            основе обезличенных данных.
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">
          3. Перечень действий с персональными данными
        </div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передача (предоставление, доступ),
            обезличивание, блокирование, удаление, уничтожение — с использованием средств
            автоматизации и без них.
          </p>
          <p class="users-consent-policy__item-paragraph">
            Распространение (публикация) моих персональных данных в составе Профиля и
            материалов, опубликованных мной на сервисе «Юрик.ру», осуществляется
            исключительно на основании отдельного Согласия на распространение персональных
            данных, предоставляемого мной в соответствии со статьей 10.1 Федерального
            закона № 152-ФЗ.
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">
          4. Передача персональных данных
        </div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            4.1. Оператор вправе поручить обработку моих персональных данных третьим лицам
            на основании заключаемых с ними договоров, включая: провайдеров хостинга,
            операторов связи и сервисы телефонии, поставщиков CRM-систем и систем
            обработки обращений, сервисы рассылок, поставщиков аналитических,
            информационных и консультационных услуг.
          </p>
          <p class="users-consent-policy__item-paragraph">
            4.2. Лица, обрабатывающие персональные данные по поручению Оператора, обязаны
            соблюдать принципы и правила обработки и защиты персональных данных,
            предусмотренные Федеральным законом № 152-ФЗ.
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">
          5. Срок действия и отзыв согласия
        </div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            5.1. Согласие действует с момента предоставления до его отзыва.
          </p>
          <p class="users-consent-policy__item-paragraph">
            5.2. Согласие может быть отозвано путем направления заявления Оператору: по
            электронной почте
            <a class="users-consent-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >
            (скан-копия подписанного заявления либо обращение с адреса электронной почты,
            указанного в Личном кабинете), заказным почтовым отправлением по юридическому
            адресу Оператора либо личным вручением уполномоченному представителю
            Оператора.
          </p>
          <p class="users-consent-policy__item-paragraph">
            5.3. В случае отзыва Оператор прекращает обработку и уничтожает персональные
            данные в срок, установленный законодательством, за исключением случаев, когда
            обработка может быть продолжена на основаниях, предусмотренных законом (в том
            числе для исполнения договора и хранения расчетных документов).
          </p>
        </div>
      </li>
      <li class="users-consent-policy__item">
        <div class="users-consent-policy__item-title">6. Заключительные положения</div>
        <div class="users-consent-policy__item-text">
          <p class="users-consent-policy__item-paragraph">
            6.1. Я подтверждаю, что ознакомлен(а) с Политикой в области обработки и
            обеспечения защиты персональных данных Оператора и положениями Федерального
            закона № 152-ФЗ.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.users-consent-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
